export default "__VITE_ASSET__D1x0WusU__"